import { render, staticRenderFns } from "./registerManagerForm.vue?vue&type=template&id=ff66995c&scoped=true&"
import script from "./registerManagerForm.vue?vue&type=script&lang=ts&"
export * from "./registerManagerForm.vue?vue&type=script&lang=ts&"
import style0 from "./registerManagerForm.vue?vue&type=style&index=0&id=ff66995c&lang=scss&scoped=true&"
import style1 from "./registerManagerForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff66995c",
  null
  
)

export default component.exports